/**
 * A login token is valid for 100 hours (server: generateToken, expiresIn 360000 s) and the
 * API enforces that since 25.09.2026. When it runs out mid-session, every request answers
 * 401 — before, the editor only showed "Unauthorized" toasts until someone reloaded.
 *
 * http.ts signals the expiry once per 401 via a window event; SessionExpiredNotice listens.
 * Deliberately no redirect: a redirect would throw away unsaved edits, while logging in
 * again in another tab replaces the token for this tab too (same localStorage).
 */
export const SESSION_EXPIRED_EVENT = 'cixon:session-expired';

/** A 401 means "your session ran out" only if a token was sent; without one it is just "not logged in". */
export function hadSessionToken(token: string | null | undefined): boolean {
  return Boolean(token) && token !== 'null' && token !== 'undefined';
}

export function signalSessionExpired(): void {
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}
